<template>
  <div class="flex h-dvh items-center justify-center">
    <GSpinner class="text-6xl text-blue-500" />
  </div>
</template>

<script setup>
definePageMeta({
  auth: useAuthStatus.UNKNOWN,
});
</script>
